import React, { useReducer, Fragment, useEffect, useState } from "react";
import {
  CustodianEntityReducer,
  initializeCustodianEntity,
  defaultStateEntity,
  ValidateContactForm,
} from "./reducer";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
  Input,
  Button,
  Table,
  Label,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import style from "./CustodianEntity.module.scss";
import CircularProgress from "../../CircularProgress/CircularProgress";
import { Field, Combobox } from "../Order/Field/Field";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import classnames from "classnames";
import ModalConfirm from "../../Asset/Modals/ModalConfirm";

const CustodianEntityContact = ({ openContact, toggle, fetchs, ...props }) => {
  const [state, dispatch] = useReducer(
    CustodianEntityReducer,
    defaultStateEntity(),
    initializeCustodianEntity(props)
  );
  const [modal, setModal] = useState({ open: false, indexContact: 0 });

  const { custody, errors, custodianContact, custodian } = state;
  useEffect(() => {
    props.callApi("GetCustodianContactType", {}).then((response) => {
      dispatch({
        type: "SET_CUSTODIAN_CONTACT_TYPE",
        response,
      });
    });
  }, []);

  const onChangeContact = (fields) => dispatch({ type: "SET_ENTITY_CONTACT", fields });

  const confirmContact = () => {
    const errors = ValidateContactForm(state);
    if (errors == false) {
      dispatch({ type: "UPDATE_VALIDATION_CONTACT_FORM", errors });
      if (props.EditContact) {
        props.updateContact({ custodianContact });
        props.onChangeUpdate({
          EditContact: false,
        });
      } else {
        props.setContact({ custodianContact });
      }
      dispatch({ type: "RESET_CONTACT" });
      props.onChangeUpdate({
        openCustodianEntityContact: false,
      });
    } else {
      dispatch({ type: "UPDATE_VALIDATION_CONTACT_FORM", errors });
    }
  };

  const ClickEditContact = (e, index) => {
    props.onChangeUpdate({
      EditContact: true,
      IndexEditContact: index,
    });
    dispatch({ type: "GET_CONTACT", e });
    props.onChangeUpdate({
      openCustodianEntityContact: true,
    });
  };

  const ClickDeleteContact = (e, index) => {
    setModal({ ...modal, open: true, indexContact: index });
  };

  const cancelContact = () => {
    dispatch({ type: "RESET_CONTACT" });
    props.onChangeUpdate({
      EditContact: false,
      openCustodianEntityContact: false,
    });
  };

  const toggleModal = (name, props = {}) => {
    setModal({ ...modal, open: false });
  };

  const onConfirm = (name) => {
    props.deleteContact(modal.indexContact);
  };

  return (
    <div>
      <ModalConfirm
        open={modal.open}
        title={"Delete Contact"}
        message={"Are you sure you want to delete Custodian Entity Contact?"}
        toggle={() => toggleModal("confirm", {})}
        onConfirm={() => onConfirm()}
      />
      {openContact ? (
        <div className={style.edit}>
          <Row>
            <Col lg={6} xs={12}>
              <Field label={"Contact Name"} error={errors.CustodianEntityContactName}>
                <Input
                  type={"text"}
                  placeholder={"Contact Name"}
                  value={custodianContact.CustodianEntityContactName || ""}
                  invalid={errors.CustodianEntityContactName}
                  onChange={(e) =>
                    onChangeContact({
                      CustodianEntityContactName: e.target.value,
                    })
                  }
                />
              </Field>
            </Col>
            <Col lg={6} xs={12}>
              <Field label={"Contact Type"}>
                <Combobox
                  style={{ background: "#edf9ff", fontWeight: 500 }}
                  value={custodianContact.CustodianEntityContactType}
                  onChange={(v) => onChangeContact({ CustodianEntityContactType: v })}
                  items={Object.values(custodianContact.contactTypes).map((key, index) => ({
                    id: [key],
                    description: [key],
                  }))}
                />
              </Field>
            </Col>
          </Row>
          <Row>
            <Col lg={6} xs={12}>
              <Field label={"Email 1"} error={errors.CustodianEntityContactEmail1}>
                <Input
                  type={"text"}
                  placeholder={"Email 1"}
                  value={custodianContact.CustodianEntityContactEmail1 || ""}
                  invalid={errors.CustodianEntityContactEmail1}
                  onChange={(e) =>
                    onChangeContact({
                      CustodianEntityContactEmail1: e.target.value,
                    })
                  }
                />
              </Field>
            </Col>
            <Col lg={6} xs={12}>
              <Field label={"Email 2"} error={errors.CustodianEntityContactEmail2}>
                <Input
                  type={"text"}
                  placeholder={"Email 2"}
                  value={custodianContact.CustodianEntityContactEmail2 || ""}
                  onChange={(e) =>
                    onChangeContact({
                      CustodianEntityContactEmail2: e.target.value,
                    })
                  }
                />
              </Field>
            </Col>
          </Row>
          <Row>
            <Col lg={6} xs={12}>
              <Field label={"Tel 1"} error={errors.CustodianEntityContactTel1}>
                <Input
                  type={"text"}
                  placeholder={"Tel 1"}
                  value={custodianContact.CustodianEntityContactTel1 || ""}
                  onChange={(e) =>
                    onChangeContact({
                      CustodianEntityContactTel1: e.target.value,
                    })
                  }
                />
              </Field>
            </Col>
            <Col lg={6} xs={12}>
              <Field label={"Tel 2"} error={errors.CustodianEntityContactTel2}>
                <Input
                  type={"text"}
                  placeholder={"Tel 2"}
                  value={custodianContact.CustodianEntityContactTel2 || ""}
                  onChange={(e) =>
                    onChangeContact({
                      CustodianEntityContactTel2: e.target.value,
                    })
                  }
                />
              </Field>
            </Col>
          </Row>
          <Row className={style.FixPaddingCol}>
            <Col>
              <Label check>
                <Input
                  type="checkbox"
                  checked={custodianContact.CustodianEntityContactTicketConfirmation}
                  value={custodianContact.CustodianEntityContactTicketConfirmation}
                  onClick={(e) =>
                    onChangeContact({
                      CustodianEntityContactTicketConfirmation:
                        !custodianContact.CustodianEntityContactTicketConfirmation,
                    })
                  }
                />{" "}
                Contact ticket confirmation?
              </Label>
            </Col>
          </Row>
          <Row>
            <Col>
              <Field label={"Notes"} error={errors.CustodianEntityContactNotes}>
                <Input
                  type={"textarea"}
                  placeholder={"Notes"}
                  value={custodianContact.CustodianEntityContactNotes}
                  onChange={(e) =>
                    onChangeContact({
                      CustodianEntityContactNotes: e.target.value,
                    })
                  }
                />
              </Field>
            </Col>
          </Row>
          <div className={style.actions}>
            <Button className={"btn-sm"} color="light" onClick={(e) => cancelContact()}>
              {true ? "Cancel" : "Close"}
            </Button>{" "}
            <LaddaButton
              className={classnames("btn btn-ladda btn-primary")}
              onClick={(e) => confirmContact()}
              data-style={EXPAND_RIGHT}
            >
              {props.EditContact ? "Edit" : "Save"}
            </LaddaButton>
          </div>
        </div>
      ) : (
        <Fragment>
          <div className={`${style.table}`}>
            <Table responsive striped>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Tel</th>
                  <th style={{ width: "1px" }}>Edit</th>
                  <th style={{ width: "1px" }}>Del.</th>
                </tr>
              </thead>
              {props.contacts.length == 0 ? (
                <tbody>
                  <EmptyContact />
                </tbody>
              ) : (
                <tbody>
                  {props.contacts.map((c, index) => (
                    <tr style={{ textAlign: "end" }}>
                      <td>{c.CustodianEntityContactName}</td>
                      <td>{c.CustodianEntityContactEmail1}</td>
                      <td>{c.CustodianEntityContactTel1}</td>
                      <td onClick={() => ClickEditContact(c, index)}>
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                      </td>
                      <td onClick={() => ClickDeleteContact(c, index)}>
                        <i class="fa fa-close" aria-hidden="true"></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </Table>
          </div>
        </Fragment>
      )}
    </div>
  );
};

const EmptyContact = () => (
  <tr className={style.empty}>
    <td colSpan="4">
      <h5 style={{ textAlign: "center" }}>No Contacts</h5>
    </td>
  </tr>
);

export function validationsContact() {
  return {
    CustodianEntityContactName: { empty: true },
    CustodianEntityContactEmail1: { empty: true },
  };
}

export default CustodianEntityContact;
